import React from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";
import {
  canManageOrganizationMember,
  isAdminOrOwner,
  canRemoveOrganizationMember,
} from "../../../../utils/organization-permissions-helpers";
import { getRoleNameById } from "./utils/manage-coaches-utils";

export const PendingTabCoachComponent = ({ locals, roleName }) => {
  const { t } = useTranslation(["dashboard", "common"]);
  const { usersOrganization, organizationRoles = [] } = locals;
  const { organizationPendingUsers = [] } = usersOrganization;

  /**
   * Delete forever from the organization
   * @param {*} e
   * @param {*} userId
   * @param {*} canManage
   */
  const deleteCoach = (e, userId, canManage) => {
    if (canManage && userId) {
      e.stopPropagation();
      e.preventDefault();
      if (
        process.browser &&
        confirm(t("manageCoaches.deleteCoachConfirm"))
      ) {
        submit(`/actions/organizations/delete-user`, {
          method: "POST",
          body: {
            userId,
          },
        });
      }
    }
  };

  /**
   * Send the email's invitation again
   * @param {*} e
   * @param {*} email
   * @param {*} canManage
   */
  const resendInvite = (e, email, canManage) => {
    if (canManage && email) {
      e.stopPropagation();
      e.preventDefault();

      submit("/actions/organizations/resend-code", {
        method: "POST",
        body: {
          email,
        },
      });
    }
  };

  return organizationPendingUsers.map((item) => {
    const { name = "", email = "", _id = "", organizationRoleId } = item;
    const canRemove =
      isAdminOrOwner(roleName) ||
      canRemoveOrganizationMember(
        roleName,
        getRoleNameById(organizationRoles, organizationRoleId)
      );
    const canManage =
      isAdminOrOwner(roleName) ||
      canManageOrganizationMember(
        roleName,
        getRoleNameById(organizationRoles, organizationRoleId)
      );

    return (
      <li key={_id}>
        <article>
          <div className="left pending">
            <SvgIcon
              src="/img/new-icons/user-circle.svg"
              alt="pending"
              className="avatar pending"
            />

            <div className="coach-info">
              <p className="p4">{email}</p>
            </div>
          </div>
          <div className="right">
            {canManage && (
              <a
                role="button"
                data-button-type="outline"
                onClick={(e) => {
                  resendInvite(e, email, canManage);
                }}
              >
                <span>{t("manageCoaches.resendInvite")}</span>
              </a>
            )}
            {canManage && (
              <button
                data-button-type="secondary"
                data-action="cancel"
                disabled={canRemove ? undefined : true}
                onClick={(e) => {
                  deleteCoach(e, _id, canRemove);
                }}
              >
                {t("common:remove")}
              </button>
            )}
          </div>
        </article>
      </li>
    );
  });
};
